import component from '@/store/modules/component';

import { new_routes } from './routers';

// import MainLayout from '../layout/MainLayout.vue';
import CommonLayout from '../layout/CommonLayout.vue';

const MainLayout = () => import('../layout/MainLayout.vue');

export const authMenu = [
    '/home',

    '/cust/home',
    '/cust/develop',
    '/cust/edit',

    '/plan/zero',
    '/plan/done',
    '/plan/zone',
    '/plan/members',
    '/plan/memberReports',

    '/base/area',
    '/base/customer',
    '/base/dictionary',

    '/system/menu',
    '/system/user',
    '/system/role',
    '/system/area',
    '/system/dept',
    '/system/post',

    '/task/dashbord',
    '/task/assgin',
    '/task/budgeting',
    '/task/return',

    '/return/list'
];

export const mark = ['/cust/home', '/cust/develop'];

export const menu = [
    {
        path: '/home',
        name: '首页',
        code: 'home001',
        type: 2,
        icon: 'House',
        show: true
    },
    {
        path: '/cust',
        name: '客户管理',
        code: 'cust001',
        type: 1,
        icon: 'User',
        show: true
    },
    {
        path: '/plan',
        name: '计划汇报',
        code: 'plan001',
        type: 1,
        icon: 'Document',
        show: true
    },
    {
        path: '/task',
        name: '任务管理',
        code: 'task001',
        type: 1,
        icon: 'Tickets',
        show: true
    },
    {
        path: '/contract',
        name: '合同管理',
        code: 'contract001',
        type: 1,
        icon: 'Tickets',
        show: true
    },
    {
        path: '/return',
        name: '回款管理',
        code: 'return001',
        type: 1,
        icon: 'Tickets',
        show: true
    },
    {
        path: '/opportunity',
        name: '商机管理',
        code: 'opportunity001',
        type: 1,
        icon: 'Memo',
        show: true
    },
    {
        path: '/operate',
        name: '问题反馈',
        type: 1,
        show: false
    },
    // {
    //     path: '/income',
    //     name: '收入管理',
    //     code: 'income001',
    //     type: 1,
    //     icon: 'Postcard',
    //     show: true
    // },
    // {
    //     path: '/quota',
    //     name: '指标管理',
    //     code: 'quota001',
    //     type: 1,
    //     icon: 'Postcard',
    //     show: true
    // },
    // {
    //     path: '/budget',
    //     name: '预算管理',
    //     code: 'budget001',
    //     type: 1,
    //     icon: 'Postcard',
    //     show: false
    // },
    // {
    //     path: '/board',
    //     name: '数据看板',
    //     code: 'board001',
    //     type: 1,
    //     icon: 'DataLine',
    //     show: false
    // },
    {
        path: '/receipts',
        name: '收入模块',
        code: 'receipts001',
        type: 1,
        icon: 'Postcard',
        show: true
    },
    // {
    //     path: '/analysis',
    //     name: '数据分析',
    //     code: 'analysis001',
    //     type: 1,
    //     icon: 'DataLine',
    //     show: false
    // },
    {
        path: '/fee',
        name: '费用管理',
        code: 'fee001',
        type: 1,
        icon: 'SetUp',
        show: true
    },
    {
        path: '/chance',
        name: '风险控制',
        code: 'chance001',
        type: 1,
        icon: 'Odometer',
        show: true
    },
    // {
    //     path: '/organization',
    //     name: '组织架构',
    //     code: 'organization001',
    //     type: 1,
    //     icon: 'Operation',
    //     show: false
    // },
    {
        path: '/performance',
        name: '绩效管理',
        code: 'performance001',
        type: 1,
        icon: 'Message',
        show: true
    },
    // {
    //     path: '/kpi',
    //     name: 'KPI管理',
    //     code: 'KPI001',
    //     type: 1,
    //     icon: 'Setting',
    //     show: true
    // },
    {
        path: '/flowable',
        name: '流程管理',
        code: 'flowable001',
        type: 1,
        icon: 'Link',
        show: true
    },
    // {
    //     path: '/system',
    //     name: '系统管理',
    //     code: 'menu001',
    //     type: 1,
    //     icon: 'Setting',
    //     show: false
    // },
    {
        path: '/analyse',
        name: '数据分析',
        code: 'analyse001',
        type: 1,
        icon: 'DataLine',
        show: true
    },
    {
        path: '/config',
        name: '基础配置',
        code: 'config001',
        type: 1,
        icon: 'Setting',
        show: true
    }
];

export const sizes = [50, 100, 200, 300, 500];

export const page = {
    pageSize: 50,
    pageNum: 1
};

export const menuType = [
    {
        name: '目录',
        value: '1'
    },
    {
        name: '菜单',
        value: '2'
    },
    {
        name: '按钮',
        value: '3'
    }
];

export const authRoutes = [];

export const mapLink = {
    南京市: 'nanjing',
    苏州市: 'suzhou',
    常州市: 'changzhou',
    镇江市: 'zhenjiang',
    无锡市: 'wuxi',
    连云港市: 'lianyungang',
    盐城市: 'yancheng',
    泰州市: 'taizhou',
    南通市: 'nantong',
    徐州市: 'xuzhou',
    淮安市: 'huaian',
    宿迁市: 'suqian',
    扬州市: 'yangzhou',
    上海市: 'shanghai'
};

export const routers = [
    {
        path: '/cust',
        name: '客户管理',
        redirect: '/cust/home',
        component: MainLayout,
        children: [
            {
                path: 'home',
                name: '客户总览',
                meta: { keep: 'keep-cust-customer', isCache: true, isCreate: true },
                component: () => import('../views/customer/index.vue')
            },

            // {
            //     path: 'signed',
            //     name: '已签约管理',
            //     meta: { keep: 'keep-cust-signed', isCache: true, isCreate: true },
            //     component: () => import('../views/customer/signed.vue')
            // },
            {
                path: 'add',
                name: '客户新增',
                meta: { keep: 'keep-edit', isCreate: false },
                component: () => import('../views/customer/edit.vue')
            },
            {
                path: 'edit',
                name: '客户编辑',
                meta: { keep: 'keep-edit', isCreate: false },
                component: () => import('../views/customer/edit.vue')
            },
            {
                path: 'other',
                name: '项目管理',
                meta: { keep: 'keep-cust-other', isCache: true, isCreate: true },
                component: () => import('../views/customer/other.vue')
            },
            {
                path: 'contacts',
                name: '客户联系人',
                meta: { keep: 'keep-cust-contacts', isCache: true, isCreate: true },
                component: () => import('../views/customer/contacts.vue')
            },
            {
                path: 'analyse',
                name: '',
                children: [
                    {
                        path: 'customer',
                        name: '',
                        meta: { keep: 'keep-analyse-board-customer', isCache: true, isCreate: true, paddingNot: true },
                        component: () => import('../views/board/customer.vue')
                    }
                ]
            }
        ]
    },
    {
        path: '/plan',
        name: '计划汇报',
        redirect: '/plan/zero',
        component: MainLayout,
        children: [
            {
                path: 'zero',
                name: '拜访计划',
                meta: { keep: 'keep-zero', isCache: true, isCreate: true },
                component: () => import('../views/plan/zero.vue')
            },
            {
                path: 'done',
                name: '实际拜访',
                meta: { keep: 'keep-done', isCache: true, isCreate: true },
                component: () => import('../views/plan/done.vue')
            },
            {
                path: 'action',
                name: 'plan-action',
                meta: { keep: 'keep-plan-action', isCache: true, isCreate: true },
                component: () => import('../views/plan/actionMain.vue')
            },
            {
                path: 'focus',
                name: 'plan-focus',
                meta: { keep: 'keep-plan-focus', isCache: true, isCreate: true },
                component: () => import('../views/plan/focusMain.vue')
            },
            {
                path: 'kpi',
                name: 'KPI管理',
                meta: { keep: 'keep-plan-kpi', isCache: true, isCreate: true },
                component: () => import('../views/kpiManage/index.vue')
            },
            {
                path: 'summary',
                name: '工作汇总',
                meta: { keep: 'keep-plan-summary', isCache: true, isCreate: true },
                component: () => import('../views/plan/total.vue')
            },
            {
                path: 'usermain',
                name: '用户汇总',
                meta: { keep: 'keep-plan-usermain', isCache: true, isCreate: true },
                component: () => import('../views/plan/workMain.vue')
            },
            {
                path: 'visit',
                name: 'plan-visit',
                meta: { keep: 'keep-plan-visit', isCache: true, isCreate: true },
                component: () => import('../views/analysis/visitCount.vue')
            }
        ]
    },
    {
        path: '/chance',
        name: 'chance',
        component: MainLayout,
        children: [
            {
                path: 'abnormal',
                name: '异常',
                meta: { keep: 'keep-plan-abnormal', isCache: true, isCreate: true },
                component: () => import('../views/chance/abnormal.vue')
            },
            {
                path: 'risk',
                name: '风险',
                meta: { keep: 'keep-plan-risk', isCache: true, isCreate: true },
                component: () => import('../views/chance/risk.vue')
            },
            {
                path: 'feedback',
                name: 'chance-feedback',
                meta: { keep: 'keep-chance-feedback', isCache: true, isCreate: true },
                component: () => import('../views/system/feedback.vue')
            }
        ]
    },
    {
        path: '/task',
        name: '任务管理',
        redirect: '/task/dashbord',
        component: MainLayout,
        children: [
            {
                path: 'dashbord',
                name: '任务总览',
                component: () => import('../views/task/dashbord.vue')
            },
            {
                path: 'assgin',
                name: '指标分解',
                component: () => import('../views/task/assgin.vue')
            },
            {
                path: 'budgeting',
                name: '预算制定',
                component: () => import('../views/task/budgeting.vue')
            },
            {
                path: 'income',
                name: '收入管理',
                component: () => import('../views/task/returnManage.vue')
            }
        ]
    },
    {
        path: '/return',
        name: '回款管理',
        component: MainLayout,
        children: [
            {
                path: 'actual',
                name: 'keep-return-actual',
                meta: { keep: 'keep-return-actual', isCache: true, isCreate: true },
                component: () => import('../views/return/actual.vue')
            },
            {
                path: 'quota',
                name: 'keep-return-quota',
                meta: { keep: 'keep-return-quota', isCache: true, isCreate: true },
                component: () => import('../views/return/quotaMain.vue')
            },
            {
                path: 'dashborad',
                name: '回款看板',
                meta: { keep: 'keep-dashborad', isCache: true, isCreate: true, paddingNot: true },
                component: () => import('../views/return/dashborad.vue')
            },
            {
                path: 'mark',
                name: '回款预填',
                meta: { keep: 'keep-mark', isCache: true, isCreate: true },
                component: () => import('../views/return/mark.vue')
            },
            {
                path: 'control',
                name: 'keep-return-control',
                children: [
                    {
                        path: 'diffcult',
                        name: 'keep-return-control-diffcult',
                        meta: { keep: 'keep-return-control-diffcult', isCache: true, isCreate: true },
                        component: () => import('../views/return/diffcultMain.vue')
                    },
                    {
                        path: 'reputation',
                        name: 'keep-return-control-reputation',
                        meta: { keep: 'keep-return-control-reputation', isCache: true, isCreate: true },
                        component: () => import('../views/return/reputationMain.vue')
                    },
                    {
                        path: 'riskRecord',
                        name: 'keep-return-control-riskRecord',
                        meta: { keep: 'keep-return-control-riskRecord', isCache: true, isCreate: true },
                        component: () => import('../views/chance/riskDiffcult.vue')
                    },
                    {
                        path: 'focusCustomer',
                        name: 'keep-focus-customer',
                        meta: { keep: 'keep-focus-customer', isCache: true, isCreate: true },
                        component: () => import('../views/return/focusCustomer.vue')
                    },
                    {
                        path: 'case',
                        name: '',
                        meta: { keep: 'keep-control-case', isCache: true, isCreate: true },
                        component: () => import('../views/return/risk/case.vue')
                    },
                    {
                        path: 'evidence',
                        name: 'keep-return-control-risk-evidence',
                        meta: { keep: 'keep-return-control-risk-evidence', isCache: true, isCreate: true },
                        component: () => import('../views/return/risk/evidence.vue')
                    },
                    {
                        path: 'risk',
                        name: '风险分析',
                        children: [
                            {
                                path: 'lower',
                                name: 'keep-return-control-risk-lower',
                                meta: { keep: 'keep-return-control-risk-lower', isCache: true, isCreate: true },
                                component: () => import('../views/return/risk/lower.vue')
                            },
                            {
                                path: 'demise',
                                name: 'keep-return-control-risk-demise',
                                meta: { keep: 'keep-return-control-risk-demise', isCache: true, isCreate: true },
                                component: () => import('../views/return/risk/demise.vue')
                            },
                            {
                                path: 'lowerRate',
                                name: '',
                                meta: { keep: 'keep-control-risk-lowerRate', isCache: true, isCreate: true },
                                component: () => import('../views/return/risk/lowerRate.vue')
                            },
                            {
                                path: 'highPeriod',
                                name: '',
                                meta: { keep: 'keep-control-risk-lowerRate', isCache: true, isCreate: true },
                                component: () => import('../views/return/risk/highCharge.vue')
                            }
                        ]
                    }
                ]
            },
            {
                path: 'data',
                name: '回款数据',
                meta: { keep: 'keep-return-data', isCache: true, isCreate: true },
                children: [
                    {
                        path: 'index',
                        name: 'keep-data-actual-index',
                        meta: { keep: 'keep-data-actual-index', isCache: true, isCreate: true },
                        component: () => import('../views/return/data.vue')
                    },
                    {
                        path: 'accumulated',
                        name: 'keep-actual-accumulated',
                        meta: { keep: 'keep-actual-accumulated', isCache: true, isCreate: true },
                        component: () => import('../views/return/actualData.vue')
                    },
                    {
                        path: 'period',
                        name: 'keep-return-overview-period',
                        meta: { keep: 'keep-return-overview-period', isCache: true, isCreate: true },
                        component: () => import('../views/return/overviewPeriod.vue')
                    },
                    {
                        path: 'letter',
                        name: 'keep-return-data-letter',
                        meta: { keep: 'keep-return-data-letter', isCache: true, isCreate: true },
                        component: () => import('../views/return/letterData.vue')
                    },
                    {
                        path: 'difficult',
                        name: '',
                        meta: { keep: 'keep-difficult', isCache: true, isCreate: true },
                        component: () => import('../views/return/difficultData.vue')
                    },
                    {
                        path: 'complete',
                        name: '',
                        meta: { keep: 'keep-data-complete', isCache: true, isCreate: true },
                        children: [
                            {
                                path: 'rate',
                                name: 'keep-return-complete-rate',
                                meta: { keep: 'keep-return-overview-rate', isCache: true, isCreate: true },
                                component: () => import('../views/return/risk/rate.vue')
                            },
                            {
                                path: 'finish',
                                name: 'keep-return-complete-finish',
                                meta: { keep: 'keep-return-overview-finish', isCache: true, isCreate: true },
                                component: () => import('../views/return/risk/finish.vue')
                            },
                            {
                                path: 'datalist',
                                name: '',
                                meta: { keep: 'keep-datalist-finish', isCache: true, isCreate: true },
                                component: () => import('../views/return/datalistFinish.vue')
                            }
                        ]
                    },
                    {
                        path: 'precent',
                        name: '',
                        meta: { keep: 'keep-data-precent', isCache: true, isCreate: true },
                        children: [
                            {
                                path: 'clinetProperty',
                                name: '',
                                meta: { keep: 'keep-precent-clinetProperty', isCache: true, isCreate: true },
                                component: () => import('../views/return/precent/clinetProprty.vue')
                            },
                            {
                                path: 'section',
                                name: '',
                                meta: { keep: 'keep-precent-section', isCache: true, isCreate: true },
                                component: () => import('../views/return/precent/section.vue')
                            }
                        ]
                    }
                ]
            },
            // {
            //     path: 'overview',
            //     name: '任务总览',
            //     children: [
            //         {
            //             path: 'index',
            //             name: 'keep-return-overview-index',
            //             meta: { keep: 'keep-return-overview-index', isCache: true, isCreate: true },
            //             component: () => import('../views/return/overview.vue')
            //         },
            //         {
            //             path: 'rate',
            //             name: 'keep-return-overview-rate',
            //             meta: { keep: 'keep-return-overview-rate', isCache: true, isCreate: true },
            //             component: () => import('../views/return/risk/rate.vue')
            //         },
            //         {
            //             path: 'finish',
            //             name: 'keep-return-overview-finish',
            //             meta: { keep: 'keep-return-overview-finish', isCache: true, isCreate: true },
            //             component: () => import('../views/return/risk/finish.vue')
            //         },
            //         {
            //             path: 'period',
            //             name: 'keep-return-overview-period',
            //             meta: { keep: 'keep-return-overview-period', isCache: true, isCreate: true },
            //             component: () => import('../views/return/overviewPeriod.vue')
            //         }
            //     ]
            // },
            {
                path: 'base',
                name: '基础数据',
                children: [
                    {
                        path: 'aging',
                        name: 'keep-return-base-aging',
                        meta: { keep: 'keep-return-base-aging', isCache: true, isCreate: true },
                        component: () => import('../views/return/aging.vue')
                    },

                    {
                        path: 'actual',
                        name: 'keep-return-base-actual',
                        meta: { keep: 'keep-return-base-actual', isCache: true, isCreate: true },
                        component: () => import('../views/return/actual.vue')
                    },
                    {
                        path: 'quota',
                        name: 'keep-return-base-quota',
                        meta: { keep: 'keep-return-base-quota', isCache: true, isCreate: true },
                        component: () => import('../views/return/quotaMain.vue')
                    },
                    {
                        path: 'charge',
                        name: '',
                        meta: { keep: 'keep-control-base-charge', isCache: true, isCreate: true },
                        component: () => import('../views/return/account/charge.vue')
                    },
                    {
                        path: 'datalist',
                        name: 'keep-return-control-datalist',
                        meta: { keep: 'keep-return-control-datalist', isCache: true, isCreate: true },
                        component: () => import('../views/return/list.vue')
                    },
                    {
                        path: 'period',
                        name: '',
                        meta: { keep: 'keep-return-base-period', isCache: true, isCreate: true },
                        component: () => import('../views/return/period.vue')
                    }
                ]
            }
        ]
    },
    {
        path: '/operate',
        name: '相关操作',
        component: MainLayout,
        children: [
            {
                path: 'question',
                name: '问题反馈',
                meta: { keep: 'keep-question', isCache: true, isCreate: true },
                component: () => import('../views/question/index.vue')
            },
            {
                path: 'viewfile',
                name: '操作手册',
                meta: { keep: 'keep-viewfile', isCache: true, isCreate: true },
                component: () => import('../views/pdf/index.vue')
            },
            {
                path: 'bindUser',
                name: '操作手册',
                meta: { keep: 'keep-bindUser', isCache: true, isCreate: true },
                component: () => import('../views/system/bindUser.vue')
            }
        ]
    },
    {
        path: '/opportunity',
        name: '商机管理',
        component: MainLayout,
        children: [
            {
                path: 'main',
                name: 'opportunity-main',
                meta: { keep: 'keep-opportunity-main', isCache: true, isCreate: true },
                component: () => import('../views/board/box/opportunity.vue')
            },
            {
                path: 'develop',
                name: '开发中管理',
                meta: { keep: 'keep-opportunity-develop', isCache: true, isCreate: true },
                component: () => import('../views/customer/develop.vue')
            }
        ]
    },
    {
        path: '/contract',
        name: '合同管理',
        component: MainLayout,
        children: [
            {
                path: 'signed',
                name: 'contract-signed',
                meta: { keep: 'keep-contract-signed', isCache: true, isCreate: true },
                component: () => import('../views/contract/signed.vue')
            }
        ]
    },
    {
        path: '/fee',
        name: '费用管理',
        redirect: '/fee/customer',
        component: MainLayout,
        children: [
            {
                path: 'analysis',
                children: [
                    {
                        path: 'main',
                        name: '费用总览',
                        meta: { keep: 'keep-fee-main', isCache: true, isCreate: true },
                        component: () => import('../views/fee/main.vue')
                    }
                ]
            },
            {
                path: 'level',
                name: 'fee-level',
                meta: { keep: 'fee-level', isCache: false, isCreate: false },
                children: [
                    {
                        path: 'year',
                        name: '',
                        children: [
                            {
                                path: 'area',
                                name: '',
                                meta: { keep: 'keep-fee-area', isCache: true, isCreate: true },
                                component: () => import('../views/fee/areaFee.vue')
                            },
                            {
                                path: 'person',
                                name: '',
                                meta: { keep: 'keep-fee-person', isCache: true, isCreate: true },
                                component: () => import('../views/fee/userFee.vue')
                            },
                            {
                                path: 'customer',
                                name: '',
                                meta: { keep: 'keep-fee-customer', isCache: true, isCreate: true },
                                component: () => import('../views/fee/customer.vue')
                            }
                        ]
                    },
                    {
                        path: 'month',
                        name: '',
                        children: [
                            {
                                path: 'customer',
                                name: '',
                                meta: { keep: 'keep-fee-customer', isCache: true, isCreate: true },
                                component: () => import('../views/fee/month.vue')
                            }
                        ]
                    }
                    // {
                    //     path: 'userFee',
                    //     name: '个人费用标准',
                    //     meta: { keep: 'keep-fee-user', isCache: true, isCreate: true },
                    //     component: () => import('../views/fee/userFee.vue')
                    // },
                    // {
                    //     path: 'areaFee',
                    //     name: '区域费用标准',
                    //     meta: { keep: 'keep-fee-area', isCache: true, isCreate: true },
                    //     component: () => import('../views/fee/areaFee.vue')
                    // },
                    // {
                    //     path: 'standard',
                    //     name: '客户费用标准',
                    //     meta: { keep: 'keep-fee-standard', isCache: true, isCreate: true },
                    //     component: () => import('../views/fee/feeStandard.vue')
                    // }
                ]
            },
            {
                path: 'reimburs',
                name: '报销记录',
                meta: { keep: 'keep-fee-reimburs', isCache: true, isCreate: true },
                component: () => import('../views/fee/expenseFee.vue')
            },
            {
                path: 'actualExpense',
                children: [
                    {
                        path: 'customer',
                        name: '客户费用登记',
                        meta: { keep: 'keep-fee-customer', isCache: true, isCreate: true },
                        component: () => import('../views/fee/useFeeDetail.vue')
                    }
                ]
            }
        ]
    },
    ...new_routes
];
